import { useEffect, useRef } from 'react';

function AnimateTitleOne() {
    const headingRef = useRef(null);

    useEffect(() => {
        const target = headingRef.current;
        if (!target) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    target.classList.add('animate');
                    observer.unobserve(target);
                }
            },
            { threshold: 0.5 }
        );

        observer.observe(target);

        return () => {
            observer.unobserve(target);
        };
    }, []);

    return (
        <h3 className="section-heading" ref={headingRef}>
            <span className="qodef-e-inner">
                <span className="qodef--word">
                    {'Atelier'.split('').map((char, index) => (
                        <span
                            className="qode--char"
                            style={{
                                '--qode-i': index,
                                marginRight: char === ' ' ? '16px' : '0px',
                            }}
                            key={index}
                        >
                            <span className="qode--char-inner">{char}</span>
                        </span>
                    ))}
                </span>
            </span>
        </h3>
    );
}

export default AnimateTitleOne;
